import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface APIStatusState {
  loadingCount: number;
  error: string | null
  success: string | null
}

const initialState: APIStatusState = {
  loadingCount: 0,
  error: null,
  success: null
}

const apiStatusSlice = createSlice({
  name: 'apiStatus',
  initialState,
  reducers: {
    incrementLoading(state) {
      state.loadingCount += 1;
    },
    decrementLoading(state) {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    setSuccess: (state, action: PayloadAction<string | null>) => {
      state.success = action.payload
    },
    clearMessages: (state) => {
      state.error = null
      state.success = null
    }
  }
})

export const selectIsLoading = (state: any) => state.apiStatus.loadingCount > 0;

export const { incrementLoading, decrementLoading, setError, setSuccess, clearMessages } = apiStatusSlice.actions
export default apiStatusSlice.reducer
